export default {
}



// WEBPACK FOOTER //
// src/store/tool/file/metadata/getters.js